import moment from "moment";
import { DeviceType } from "../helpers/constants/constant";

export const getDeviceType = () => {
    const ua = navigator.userAgent;

    if (/tablet|ipad|playbook|silk/i.test(ua)) {
        return DeviceType.TABLET;
    }
    if (
        /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
    ) {
        return DeviceType.MOBILE;
    }
    return DeviceType.PC;
};

export const GSTValidator = (gstNumber) => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/i;
    return gstRegex.test(gstNumber);
}

export const PANValidator = (PANNumber) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;
    return panRegex.test(PANNumber);
}


export const IFSCValidator = (ifsc) => {
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    return ifscRegex.test(ifsc);
}

export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}


export const isValidUPI = (upi) => {
    const upiRegex = /^[a-zA-Z0-9._-]{2,256}@[a-zA-Z]{2,64}$/;
    return upiRegex.test(upi);
}

export const phoneNumberValidator = (phoneNumber) => {
    if (!phoneNumber) return false;
    const phoneRegex = /^(?:\+91[\-\s]?|0)?[6-9]\d{9}$/;
    return phoneRegex.test(String(phoneNumber).trim());
}



export const getDateBetweenValidations = (selectedDate, fromDate, toDate) => {
    if (!selectedDate) return true;
    const selected = moment(selectedDate);
    if (!selected.isValid()) return false;

    if (fromDate && toDate) {
        return selected.isBetween(moment(fromDate), moment(toDate), "day", "[]");
    }
    if (fromDate) {
        return selected.isSameOrAfter(moment(fromDate), "day");
    }
    if (toDate) {
        return selected.isSameOrBefore(moment(toDate), "day");
    }
    return true;
};

export const checkDateBetweenValidations = getDateBetweenValidations;

export const getRelativeDateValidations = (selectedDate, beforeDays, afterDays) => {
    if (!selectedDate) return true;
    const selected = moment(selectedDate);
    if (!selected.isValid()) return false;

    const today = moment().startOf("day");
    const minDate = beforeDays != null && beforeDays !== "" ? moment(today).subtract(Number(beforeDays), "days").startOf("day") : null;
    const maxDate = afterDays != null && afterDays !== "" ? moment(today).add(Number(afterDays), "days").endOf("day") : null;

    if (minDate && maxDate) {
        return selected.isBetween(minDate, maxDate, "day", "[]");
    }
    if (minDate) {
        return selected.isSameOrAfter(minDate, "day");
    }
    if (maxDate) {
        return selected.isSameOrBefore(maxDate, "day");
    }
    return true;
};

export const getRelativeDateRangeText = (beforeDays, afterDays) => {
    const today = moment().startOf("day");
    const minDate = beforeDays != null && beforeDays !== "" ? moment(today).subtract(Number(beforeDays), "days").format("DD/MM/YYYY") : null;
    const maxDate = afterDays != null && afterDays !== "" ? moment(today).add(Number(afterDays), "days").format("DD/MM/YYYY") : null;

    if (minDate && maxDate) {
        return `Date must be between ${minDate} and ${maxDate} (${beforeDays} days before and ${afterDays} days after today).`;
    }
    if (minDate) {
        return `Date must be on or after ${minDate} (within ${beforeDays} days before today).`;
    }
    if (maxDate) {
        return `Date must be on or before ${maxDate} (within ${afterDays} days after today).`;
    }
    return "";
};

export const isRelativeDateValidation = (val) => {
    if (val === undefined || val === null || val === "") return false;
    if (typeof val === "number") return true;
    const str = String(val).trim();
    return !str.includes("-") && !str.includes("/") && !isNaN(Number(str));
};

export const checkTextLengthValidator = (text, fromLength, toLength) => {

    return text.length >= parseInt(fromLength) && text.length <= parseInt(toLength);
}

export const checkTimeBetweenValidations = (selectedTime, fromTime, toTime) => {
    const isBetween = moment(selectedTime, "HH:mm").isBetween(
        moment(fromTime, "HH:mm:ss"),
        moment(toTime, "HH:mm:ss"),
        "minute",
        "[]"
    );

    return isBetween
}

export const changeTimeFormat = (time, fromFormat = "HH:mm:ss", toFormat = "hh:mm A") => {
    return moment(time, fromFormat).format(toFormat)
}

export const changeDateFormat = (date, fromFormat = "YYYY-MM-DD", toFormat = "DD/MM/YYYY") => {
    return moment(date, fromFormat).format(toFormat)
}